import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const fetchDesignation = () => {
  return apiClient(ENDPOINTS.DESIGNATION, { method: "GET" });
};

export const createDesignation = (designationData) => {
  return apiClient(
    ENDPOINTS.DESIGNATION,
    { method: "POST", body: designationData },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const updateDesignation = (id, updatedData) => {
  return apiClient(`${ENDPOINTS.DESIGNATION}/${id}`, {
    method: "PUT",
    body: updatedData,
  });
};

export const deleteDesignation = (designationId) => {
  return apiClient(`${ENDPOINTS.DESIGNATION}/${designationId}`, {
    method: "DELETE",
  });
};
